import { render } from "./HCFMain.vue?vue&type=template&id=c1db66e2"
import script from "./HCFMain.vue?vue&type=script&lang=js"
export * from "./HCFMain.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__